import { DownloadPalletsExportDropdown } from "components/dialogs/ExportDialog/DownloadPalletsExportDropdown";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import React from "react";
import { TopToolbar, sanitizeListRestProps, useListContext } from "react-admin";

import { InventoryListExportModal } from "../../../components/dialogs/InventoryListExportDialog";

export const InventoryListActions = (props) => {
	const { className, filters, translate, ...rest } = props;
	const { resource, displayedFilters, filterValues, showFilter } = useListContext(props);
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();

	const exportFilters = {
		...filterValues,
		is_inventory_list: true,
	};

	if (globalFilters?.terminal_id?.[0]) {
		exportFilters.terminal_id = globalFilters.terminal_id[0];
	}

	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			<DownloadPalletsExportDropdown filters={exportFilters} filenamePrefix="inventory_list" />
			<InventoryListExportModal filterValues={filterValues} />

			{filters &&
				React.cloneElement(filters, {
					resource,
					showFilter,
					displayedFilters,
					filterValues,
					context: "button",
				})}
		</TopToolbar>
	);
};
